export default "__VITE_ASSET__O8La71Bv__"